import React, { useEffect } from 'react';
import { styled, Theme } from '@material-ui/core/styles';
import MenuBar from './MenuBar/MenuBar';
import MobileTopMenuBar from './MobileTopMenuBar/MobileTopMenuBar';
import PreJoinScreens from './PreJoinScreens/PreJoinScreens';
import ReconnectingNotification from './ReconnectingNotification/ReconnectingNotification';
import RecordingNotifications from './RecordingNotifications/RecordingNotifications';
import Room from './Room/Room';

import useHeight from '../../hooks/useHeight/useHeight';
import useRoomState from '../../hooks/useRoomState/useRoomState';
import WaitingRoom from './WitingRoom/WaitingRoom';
import { _extLog } from '../../tools/ExternalLogs';

const Container = styled('div')({
  display: 'grid',
  gridTemplateRows: '1fr auto',
});

const Main = styled('main')(({ theme }: { theme: Theme }) => ({
  overflow: 'hidden',
  paddingBottom: `${theme.footerHeight}px`, // Leave some space for the footer
  background: `${theme.palette.background.default}`,
  [theme.breakpoints.down('sm')]: {
    paddingBottom: `${theme.mobileFooterHeight + theme.mobileTopBarHeight}px`, // Leave some space for the mobile header and footer
  },
}));

export default function App() {
  const roomState = useRoomState();

  useEffect(() => {
    _extLog(`Room state ${roomState}`);
  }, [roomState]);

  // Here we would like the height of the main container to be the height of the viewport.
  // On some mobile browsers, 'height: 100vh' sets the height equal to that of the screen,
  // not the viewport. This looks bad when the mobile browsers location bar is open.
  // We will dynamically set the height with 'window.innerHeight', which means that this
  // will look good on mobile browsers even after the location bar opens or closes.
  const height = useHeight();

  return (
    <Container style={{ height }}>
      {roomState === 'disconnected' ? (
        <PreJoinScreens />
      ) : (
        <Main>
          <WaitingRoom />
          <ReconnectingNotification />
          <RecordingNotifications />
          <MobileTopMenuBar />
          <Room />
          <MenuBar />
        </Main>
      )}
    </Container>
  );
}
